import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHorse = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 411,
	height: 359,
	viewBox: "0 0 411 359",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_718_1139)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M209.19 358.3C298.936 358.3 371.69 285.546 371.69 195.8C371.69 106.054 298.936 33.3 209.19 33.3C119.444 33.3 46.6899 106.054 46.6899 195.8C46.6899 285.546 119.444 358.3 209.19 358.3Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M309.61 303.77L249.99 303.5C249.16 303.5 248.49 302.83 248.49 302C248.49 301.17 249.16 300.5 249.99 300.5L309.61 300.77C310.44 300.77 311.11 301.44 311.11 302.27C311.11 303.1 310.44 303.77 309.61 303.77Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M241.96 303.5H60.73C59.9 303.5 59.23 302.83 59.23 302C59.23 301.17 59.9 300.5 60.73 300.5H241.97C242.8 300.5 243.47 301.17 243.47 302C243.47 302.83 242.8 303.5 241.97 303.5H241.96Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.3601C87.7401 290.69 82.3501 285.3 82.3501 278.68V62.46C82.3501 55.84 87.7401 50.45 94.3601 50.45H260.34",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.36C87.74 290.69 82.35 285.3 82.35 278.68V62.46C82.35 55.84 87.74 50.45 94.36 50.45H260.34M260.33 37.63H94.35C80.64 37.63 69.52 48.75 69.52 62.46V278.68C69.52 292.39 80.64 303.51 94.35 303.51H260.33C274.04 303.51 285.16 292.39 285.16 278.68V62.46C285.16 48.75 274.04 37.63 260.33 37.63Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 0.309998C187.69 0.309998 196.31 8.93 196.31 19.55V30.24H157.83V19.55C157.83 8.93 166.45 0.309998 177.07 0.309998Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 24.5C180.958 24.5 184.11 21.3481 184.11 17.46C184.11 13.5719 180.958 10.42 177.07 10.42C173.182 10.42 170.03 13.5719 170.03 17.46C170.03 21.3481 173.182 24.5 177.07 24.5Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_718_1139",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 119,
				y: 25,
				width: 116,
				height: 40,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_718_1139)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M241.63 55.98H112.51V68.12H241.63V55.98Z",
					fill: "#FFB100"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M335.95 139.12C335.97 139.62 335.78 140.12 335.43 140.47L322.82 153.09C322.5 153.41 322.09 153.63 321.65 153.67C321.11 153.71 320.6 153.53 320.23 153.15L314.8 147.72C314.44 147.36 314.25 146.87 314.28 146.37C314.3 145.87 314.54 145.39 314.93 145.07C315.63 144.49 316.71 144.56 317.38 145.23L321.47 149.32C321.47 149.32 321.52 149.34 321.53 149.32L332.87 137.98C333.54 137.31 334.61 137.24 335.32 137.82C335.71 138.14 335.94 138.62 335.97 139.12H335.95Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 125.66C139.845 125.66 147.68 117.825 147.68 108.16C147.68 98.495 139.845 90.66 130.18 90.66C120.515 90.66 112.68 98.495 112.68 108.16C112.68 117.825 120.515 125.66 130.18 125.66Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 100.46H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 116.94H228.01",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 191.1C139.845 191.1 147.68 183.265 147.68 173.6C147.68 163.935 139.845 156.1 130.18 156.1C120.515 156.1 112.68 163.935 112.68 173.6C112.68 183.265 120.515 191.1 130.18 191.1Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 165.89H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 182.38H210.64",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 256.54C139.845 256.54 147.68 248.705 147.68 239.04C147.68 229.375 139.845 221.54 130.18 221.54C120.515 221.54 112.68 229.375 112.68 239.04C112.68 248.705 120.515 256.54 130.18 256.54Z",
				fill: "#3F8BFD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 231.33H192.76",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 247.82H228.01",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 109.32L128.38 113.68L137.55 104.51",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 174.3L128.38 178.65L137.55 169.48",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 240.23L128.38 244.58L137.55 235.41",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.6899 169.29C21.7099 169.79 21.5199 170.29 21.1699 170.64L8.55993 183.26C8.23993 183.58 7.82993 183.8 7.38993 183.84C6.84993 183.88 6.33993 183.7 5.96993 183.32L0.53993 177.89C0.17993 177.53 -0.0100701 177.04 0.0199299 176.54C0.0399299 176.04 0.27993 175.56 0.66993 175.24C1.36993 174.66 2.44993 174.73 3.11993 175.4L7.20993 179.49C7.20993 179.49 7.25993 179.51 7.26993 179.49L18.6099 168.15C19.2799 167.48 20.3499 167.41 21.0599 167.99C21.4499 168.31 21.6799 168.79 21.7099 169.29H21.6899Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M278.97 1.69998C278.99 2.19998 278.8 2.69998 278.45 3.04998L265.84 15.67C265.52 15.99 265.11 16.21 264.67 16.25C264.13 16.29 263.62 16.11 263.25 15.73L257.82 10.3C257.46 9.93998 257.27 9.44998 257.3 8.94998C257.32 8.44998 257.56 7.96998 257.95 7.64998C258.65 7.06998 259.73 7.13998 260.4 7.80998L264.49 11.9C264.49 11.9 264.54 11.92 264.55 11.9L275.89 0.559976C276.56 -0.110024 277.63 -0.180024 278.34 0.399976C278.73 0.719976 278.96 1.19998 278.99 1.69998H278.97Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M410.35 95.27C410.39 96.04 410.09 96.8 409.55 97.35L390.17 116.73C389.68 117.22 389.05 117.56 388.37 117.62C387.55 117.69 386.76 117.4 386.19 116.82L377.84 108.47C377.29 107.92 377 107.16 377.04 106.39C377.08 105.62 377.44 104.89 378.04 104.4C379.12 103.51 380.77 103.61 381.8 104.64L388.09 110.93C388.09 110.93 388.16 110.96 388.19 110.93L405.61 93.51C406.64 92.48 408.28 92.38 409.37 93.27C409.97 93.77 410.33 94.49 410.37 95.27H410.35Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M370.08 172H374.79C386.99 172 396.9 181.91 396.9 194.11V242.42C396.9 243.71 395.85 244.76 394.56 244.76C381.06 244.76 370.09 233.8 370.09 220.29V172H370.08Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M229.25 158.07H343.48C364.85 158.07 382.2 175.42 382.2 196.79V232.06H229.26V158.08L229.25 158.07Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M251.15 226.23H229.25V290.16H251.15V226.23Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M229.25 290.15H251.15V293.07C251.15 298.83 246.47 303.5 240.72 303.5H231.21C230.13 303.5 229.25 302.62 229.25 301.54V290.14V290.15Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M268.55 290.15H290.45V293.07C290.45 298.83 285.77 303.5 280.02 303.5H270.51C269.43 303.5 268.55 302.62 268.55 301.54V290.14V290.15Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M320.25 290.15H342.15V293.07C342.15 298.83 337.47 303.5 331.72 303.5H322.21C321.13 303.5 320.25 302.62 320.25 301.54V290.14V290.15Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M360.29 290.15H382.19V293.07C382.19 298.83 377.51 303.5 371.76 303.5H362.25C361.17 303.5 360.29 302.62 360.29 301.54V290.14V290.15Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M290.45 226.23H268.55V290.16H290.45V226.23Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M342.15 226.23H320.25V290.16H342.15V226.23Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M382.19 226.23H360.29V290.16H382.19V226.23Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M263.51 98.2C270.95 98.2 276.99 104.24 276.99 111.68V159.34C276.99 166.78 270.95 172.82 263.51 172.82V98.2Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M263.51 172.82L230.78 170.14C222.35 170.14 215.51 163.3 215.51 154.87V84.47H263.51V172.82Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M216.93 73.98H217.48C223.27 73.98 227.98 78.68 227.98 84.48H215.52V75.4C215.52 74.62 216.15 73.98 216.94 73.98H216.93Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M263.51 84.47H251.05C251.05 78.68 255.75 73.97 261.55 73.97H262.1C262.88 73.97 263.52 74.6 263.52 75.39V84.47H263.51Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M229.34 84.47H249.69V108.25C249.69 109.99 248.28 111.4 246.54 111.4H244.82C236.27 111.4 229.33 104.46 229.33 95.91V84.47H229.34Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M215.52 152.53H251.06V154.87C251.06 163.3 244.22 170.14 235.79 170.14H230.8C222.37 170.14 215.53 163.3 215.53 154.87V152.53H215.52Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M227.51 165.09C228.83 165.09 229.9 164.02 229.9 162.7C229.9 161.38 228.83 160.31 227.51 160.31C226.19 160.31 225.12 161.38 225.12 162.7C225.12 164.02 226.19 165.09 227.51 165.09Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M239.06 165.09C240.38 165.09 241.45 164.02 241.45 162.7C241.45 161.38 240.38 160.31 239.06 160.31C237.74 160.31 236.67 161.38 236.67 162.7C236.67 164.02 237.74 165.09 239.06 165.09Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M226.85 121.83C226.85 120.273 225.587 119.01 224.03 119.01C222.473 119.01 221.21 120.273 221.21 121.83V126.38C221.21 127.937 222.473 129.2 224.03 129.2C225.587 129.2 226.85 127.937 226.85 126.38V121.83Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M245.37 121.83C245.37 120.273 244.107 119.01 242.55 119.01C240.993 119.01 239.73 120.273 239.73 121.83V126.38C239.73 127.937 240.993 129.2 242.55 129.2C244.107 129.2 245.37 127.937 245.37 126.38V121.83Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M359.95 249.86C371.371 249.86 380.63 240.601 380.63 229.18C380.63 217.759 371.371 208.5 359.95 208.5C348.529 208.5 339.27 217.759 339.27 229.18C339.27 240.601 348.529 249.86 359.95 249.86Z",
				fill: "#6BA6FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_718_1139",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 410.36,
			height: 358.3,
			fill: "white"
		})
	}) })]
});
export default SvgHorse;
